import React from "react"
import ZdqConnectorStatus from "../../components/ZdqConnectorStatus"
import { SNOWFLAKE } from "../../Constants"

function ZdqSnowflakeConnectorStatus() {
    return <ZdqConnectorStatus vendor={SNOWFLAKE}></ZdqConnectorStatus>
}

export default ZdqSnowflakeConnectorStatus
